module.exports = __webpack_public_path__ + "img/CCLF_infographic-12.1e1d20ce.png";